import Component from "./Toast";
import ButtonsView from "../components/ButtonsView/ToastButtonsView";
import ToastIcon from "../components/Icon/ToastIcon";

interface IToastExtensions {
    ToastIcon: typeof ToastIcon;
    ButtonsView: typeof ButtonsView;
}

export const Toast: typeof Component & IToastExtensions = Object.assign(
    Component,
    {
        ToastIcon,
        ButtonsView,
    },
);
